import React from 'react'

import { Avatar } from '@mui/material'

import { isScreenSizeSmall } from '../../../common/utils'

type UserAvatarProps = {
  name: string
  color?: string
  bgcolor?: string
}

/**
 * UserAvatar component displays the first letter of the user's name inside an avatar.
 * The size of the avatar adjusts based on the screen size.
 *
 * @param {string} name - The name of the user.
 * @param {string} [color='#0096d6'] - The font color of the avatar text.
 * @param {string} [bgcolor='white'] - The background color of the avatar.
 * @returns {JSX.Element} The UserAvatar component.
 */
const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  color = '#0096d6',
  bgcolor = 'white',
}) => {
  const getAvatarContent = (name: string) => {
    const words = name.trim().split(' ')
    if (words.length > 1) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase()
    } else {
      return name.substring(0, 2).toUpperCase()
    }
  }

  const avatarContent = getAvatarContent(name)

  return (
    <Avatar
      sx={{
        bgcolor: bgcolor,
        color: color,
        width: isScreenSizeSmall() ? 60 : 28,
        height: isScreenSizeSmall() ? 60 : 28,
        fontSize: isScreenSizeSmall() ? '2.5rem' : '1rem',
      }}
    >
      {avatarContent}
    </Avatar>
  )
}

export default UserAvatar
